import { NavBarLeft, NavBarTop } from '@components-common/layouts';
import { menuTop } from './menu.top';
import { PublicLayout } from '../../components-system/layouts/PublicLayout';
import { indexBy } from 'ramda';
import { Outlet } from 'react-router-dom';
import { RoleSwitcher } from '../../components-common/layout/RoleSwitcher';
import { menuCourse } from './menu.course';

export const publicLayout = {
  cat: "layout",
  type: "public",
  id: "layout.public",
  Component: PublicLayout,//LayoutPublic,
  props: {
    title: 'Public',
    sections: indexBy(x => x.id,[
      {
        id: "content",
        components: [
          {
            Component: Outlet
          }
        ]
      },
      {
        id: "header",
        components: [
        {
          id: "top_bar",
          cat: "menu",
          type: "icons",
          Component: NavBarTop,
          props: {
            menuItems: [],
            route: "/"
          },
          actions: [
            {
              prop: "menuItems",
              value: menuTop,
            }
          ]
        }
      ] as any
      }
    ]),
  }
} as any

